function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#828282",
  stroke: "#828282",
  strokeWidth: 0.357,
  d: "M18.309 7.962H38.384V8.578H18.309z",
  transform: "rotate(90 18.309 7.962)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#828282",
  d: "M28.217 18.486H48.649V19.459H28.217z",
  transform: "rotate(-180 28.217 18.486)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 17.285,
  stroke: "#828282",
  strokeWidth: 1.43
});

var SvgIcImport = function SvgIcImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_import.31520dd2.svg";
export { ForwardRef as ReactComponent };